<div class="target-panel">
  @if (primarySkin() && !upgraderService.isProcessing()) {
    <button class="target-panel__close-btn" (click)="onClearTargets()">
      <svg-icon
        class="flex items-center justify-center s-20 icon-gray"
        src="assets/icons/updater/close.svg"
        [applyClass]="true"
      />
    </button>
  }

  @if (primarySkin()) {
    <p class="target-panel__skin-name">{{ primarySkin()!.name }}</p>
    <div class="target-panel__display">
      <app-target-frame-svg class="target-panel__frame" [color]="primarySkin()!.color"/>
      <app-target-glow-svg
        class="target-panel__glow"
        [class.target-panel__glow--pulse]="upgraderService.state() === 'idle'"
        [color]="primarySkin()!.color"
      />
      <img
        class="target-panel__image"
        [src]="primarySkin()!.image"
        [alt]="primarySkin()!.name"
      />
    </div>

    }

  @if (primarySkin()) {
    <app-upgrader-items-info
      [skins]="sortedSkins()"
      [price]="upgraderService.selectedTargetSkinsPrice()"
      [skipFirst]="true"
    />
  } @else {
    <svg-icon
      class="flex items-center justify-center target-panel__silhouette icon-dark"
      src="assets/icons/updater/empty.svg"
      [applyClass]="true"
    />
    <p class="target-panel__helper-text">Select an item you want to obtain</p>
  }

  <div class="target-panel__controls">
    <button
      class="button button--style-yellow target-panel__upgrade-btn"
      [disabled]="!upgraderService.isValid() || upgraderService.isProcessing()"
      (click)="onUpgrade()"
    >
      {{ upgraderService.isProcessing() ? 'Upgrading...' : 'Upgrade' }}
    </button>

    <button
      class="button target-panel__fast-btn"
      [class.target-panel__fast-btn--active]="upgraderService.isFastMode()"
      (click)="onToggleFastMode()"
      title="Fast animation mode"
    >
      <svg-icon
        class="flex items-center justify-center s-16"
        src="assets/icons/updater/fast.svg"
        [class.icon-yellow]="upgraderService.isFastMode()"
        [class.icon-gray]="!upgraderService.isFastMode()"
        [applyClass]="true"
      />
    </button>
  </div>

  @if (primarySkin()) {
    <div class="target-panel__multiplier">
      <span class="target-panel__multiplier-label">Multiplier:</span>
      <span class="target-panel__multiplier-value">
        x{{ upgraderService.selectedTargetSkinsPrice() > 0 && upgraderService.totalWagerValue() > 0 ? (upgraderService.selectedTargetSkinsPrice() / upgraderService.totalWagerValue() | number:'1.2-2') : '0.00' }}
      </span>
    </div>
  }
</div>
